import axiosClient from "../axiosInstance";

/**
 * BSA member CSV import: district list, dry-run preview and the import
 * itself. Admin only for preview/import.
 */

export const getBsaDistricts = async () => {
  const response = await axiosClient.get("/bsa/districts");
  return response.data;
};

export const previewMemberImport = async (rows, districtId, districtName) => {
  const response = await axiosClient.post("/admin/members/preview", {
    rows,
    districtId,
    districtName,
  });
  return response.data;
};

export const importMembers = async (rows, districtId, districtName) => {
  const response = await axiosClient.post("/admin/members/import", {
    rows,
    districtId,
    districtName,
  });
  return response.data;
};

/** Start a background member gender sync (all districts when null). */
export const startGenderSync = async (districtId) => {
  const response = await axiosClient.post("/admin/members/sync-genders/start", {
    districtId: districtId || null,
  });
  return response.data;
};

/** Poll a sync job for progress and, when done, its result. */
export const getGenderSyncStatus = async (jobId) => {
  const response = await axiosClient.get(
    `/admin/members/sync-genders/${jobId}`,
  );
  return response.data;
};

const membersService = {
  getBsaDistricts,
  previewMemberImport,
  importMembers,
  startGenderSync,
  getGenderSyncStatus,
};

export default membersService;
